import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin } from '@microsoft/applicationinsights-react-js'

import { config } from '@skytech/config'

const getAppInsights = () => {
  const instrumentationKey = config.VITE_APP_INSTRUMENTATION_KEY
  const appName = config.VITE_APP_NAME

  if (!instrumentationKey || !appName) {
    console.warn('Instrumentation key or app name not found. Monitoring disabled.')
    return { appInsights: null, reactPlugin: null }
  }

  const reactPlugin = new ReactPlugin()
  const appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: instrumentationKey,
      extensions: [reactPlugin],
      disableFetchTracking: false,
      disableAjaxTracking: false,
      loggingLevelConsole: 2,
      enableAutoRouteTracking: true,
      disablePageUnloadEvents: ['unload'],
    },
  })

  appInsights.loadAppInsights()

  // Set the cloud role name for all telemetry items
  appInsights.addTelemetryInitializer(envelope => {
    if (!envelope.data) envelope.data = {}
    if (typeof envelope.data === 'object') {
      envelope.data.appName = appName
    }

    if (!envelope.tags) envelope.tags = {}
    if (typeof envelope.tags === 'object') {
      envelope.tags['ai.cloud.role'] = appName
    }
  })

  // Global error tracking for runtime errors
  window.addEventListener('error', event => {
    appInsights.trackException({
      exception: event.error,
      severityLevel: 3,
    })
  })

  window.addEventListener('unhandledrejection', event => {
    appInsights.trackException({
      exception: event.reason,
      severityLevel: 4,
    })
  })

  return { appInsights, reactPlugin }
}

export const { appInsights, reactPlugin } = getAppInsights()
